import { Component, Inject, OnInit } from '@angular/core';
import { HttpService } from '../../../../../../core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Constants } from '../../../../../../core/services/constants.service';
import { environment } from '../../../../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-document-dialog',
  templateUrl: './documentDialog.component.html',
  styleUrls: ['./documentDialog.component.scss']
})

export class DocumentDialogComponent implements OnInit {
  projectCode: any;
  selectedTermsAttachments = [];
  SERVER_URL = environment.SERVER_URL;
  VERIFICATION_CODE_URL = environment.VERIFICATION_CODE_URL;


  constructor(private httpService: HttpService,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit(): void {
    console.log(this.data);
    for(let vo of this.data.documents) {
      vo.fileType = this.getFileType(vo.fileName)
    }
    // this.data.projectCode.subscribe((res: any) => {
    //   this.projectCode = res.projectCode;
    //   console.log(this.projectCode);
    // })

    // this.route.queryParams.subscribe(params => {
    //   console.log(params);
    //   this.projectCode = params.projectCode;
    // });
    this.projectCode = this.data.projectCode;
  }

  onFileChangeForDocuments(event) {
    if (event.target.files[0].size > 1048576) {
      this.toastrService.error('Failed to update file (max 1MB)');
      return
    }
    console.log(event.target.files, event.target.files[0]);
    if (event.target.files && event.target.files[0]) {
      const filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        // const reader = new FileReader();
        console.log('hi:', event.target.files[i]);
        if (event.target.files[i].size <= Constants.UPLOAD_TERMS_FILE_SIZE) {
          this.selectedTermsAttachments.push(event.target.files[i]);
        }
        console.log(this.selectedTermsAttachments);

        // reader.onload = (e: any) => {
        //   console.log(e.target.result);
        //   this.images.push(e.target.result);
        //
        //   this.picturesForm.patchValue({
        //     fileSource: this.images
        //   });
        // };
        //
        // reader.readAsDataURL(event.target.files[i]);
      }
    }
  }

  getFileType(fileName:any){
    
    const arr = fileName.split('.')
    const name = arr[arr.length-1];
    if(['pdf'].includes(name)) {
      return 'pdficon.svg'
    }
    else {
      return 'file.svg'
    }

    
  }

  uploadDocuments() {
    if (this.selectedTermsAttachments.length > 0) {
      const fd = new FormData();
      fd.append('id', this.data.propertyId);
      // this.selectedTermsAttachments.forEach((file) => {
      //   fd.append('files', file);
      // });
      fd.append('files', this.selectedTermsAttachments[this.selectedTermsAttachments.length - 1]);

      // this.httpService.updateProperty(this.data.propertyId, fd).subscribe((res: any) => {
      //   console.log(res);
      // });
      this.httpService.addPropertyDocument(this.data.propertyId, fd).subscribe((res: any) => {
        console.log(res);
        if (res.code === 1) {
          
  
          this.data.documents = res.data;
          for(let vo of this.data.documents) {
            vo.fileType = this.getFileType(vo.fileName)
          }
        }
      });
    } else {
      return;
    }
  }

  openTerms(fileName) {
    // this.projectCode = this.route.queryParams.subscribe(params => {
    //   console.log(params);
    //   this.projectCode = params.projectCode;
    console.log(this.projectCode);
    window.open(this.VERIFICATION_CODE_URL + 'files/' + this.projectCode + '/properties/' + this.data.unitNumber + '/' + fileName);

    // });
  }

  deleteDocument(documentId) {
    console.log(documentId);
    this.httpService.deletePropertyDocument(this.data.propertyId, documentId).subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {
        this.data.documents = this.data.documents.filter(doc => doc.id !== documentId);
        this.toastrService.success('Document has been deleted.');
      } else {
        this.toastrService.error('Failed to upload document.');
      }
    });
  }

  cancel() {
    this.dialogRef.close({ documents: this.data.documents });
  }
}
